import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useRelatedDocuments } from '@features/invoices/hooks/useRelatedDocuments'
import type { RelatedDocumentWithLink } from '@features/invoices/types/relatedDocument'

import { useQuote } from '../../../../../../../contexts/quoteContext'
import { getQuoteRelatedInvoices } from '../utils/getQuoteRelatedInvoices'

export const useQuoteRelatedInvoices = (): RelatedDocumentWithLink[] => {
  const { t } = useTranslation()
  const { quote } = useQuote()

  const relatedInvoices = useMemo(() => getQuoteRelatedInvoices(quote?.relatedInvoices, t), [quote?.relatedInvoices, t])

  return useRelatedDocuments(relatedInvoices)
}
